import isObject from './isObject.js';

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

export default isStrictComparable;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_isStrictComparable.js
// module id = 544
// module chunks = 1